import styled from 'styled-components';
import { Greyscale, Core } from 'themes/rebrand/colours';
import { BREAKPOINTS } from 'constants/breakpoints';
import { Circle, ArrowRight } from 'react-feather';

const MOBILE_BREAKPOINT = `${BREAKPOINTS.lg.max}px`;

export const ResultsContainer = styled('div')`
  display: flex;
  flex-direction: row;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    flex-direction: column;
  }
`;

export const SearchResultsTableContainer = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
    margin-bottom: 1rem;
  }
`;

export const MobileDatePickerHeader = styled('div')`
  display: none;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: flex;
    flex-direction: column;
    padding: 0.5rem 0;
    margin-bottom: 1rem;
  }
`;

export const MobileJourneyInfo = styled('div')`
  font-size: 14px;
  padding: 0.5rem;
`;

export const BoldText = styled('span')`
  font-weight: 600;
`;

export const CollapseHeader = styled('div')`
  display: none;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem;
    background: ${(props) => props.bgColor || Greyscale.MistGrey};
    border: 1px solid ${Greyscale.SilverGrey};
    border-radius: 4px;
    cursor: pointer;
    user-select: none;
    margin-bottom: 0.5rem;
    transition: background-color 0.2s;
    font-size: 14px;

    &:hover {
      background: ${(props) => (props.bgColor ? `${props.bgColor}dd` : Greyscale.SilverGrey)};
    }
  }
`;

export const CollapseTitle = styled('div')`
  font-weight: 600;
  font-size: 16px;
  color: ${(props) => props.textColor || Greyscale.Charcoal};
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 14px;
  }
`;

export const SelectedFareInfo = styled('div')`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.textColor || Core.CoreBlue};
  margin-top: 0.25rem;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 16px;
  }
`;

export const ExistingFareInfo = styled(SelectedFareInfo)`
  opacity: 0.8;
  font-size: 14px;
`;

export const StyledCircle = styled(Circle)`
  margin: 0 8px;
`;

export const StyledArrowRight = styled(ArrowRight)`
  margin: 0 4px;
  vertical-align: middle;
`;

export const CollapseIcon = styled('span')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.textColor || Greyscale.SteelGrey};
  transition: transform 0.3s ease-in-out;

  svg {
    transition: all 0.3s ease-in-out;
  }

  &:hover {
    transform: scale(1.1);
  }
`;

export const CollapsibleContent = styled('div')`
  max-height: 10000px;
  overflow: visible;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    max-height: ${(props) => (props.isExpanded ? '10000px' : '0')};
    overflow: hidden;
    transition: max-height 0.3s ease-in-out;
  }
`;
